import type { HTMLAttributes, ReactNode } from "react";
import { cx } from "../cx";
import styles from "./Card.module.css";

export interface CardProps extends Omit<HTMLAttributes<HTMLDivElement>, "title"> {
  /** `legacy` = cl-card (2px radius); `settings` = workspace-settings card (12px radius, hairline border). */
  variant?: "legacy" | "settings";
  /** 40px grey header strip (legacy cards only look right with it). */
  header?: ReactNode;
  /** Drop body padding, e.g. for a Table or a list of rows. */
  flush?: boolean;
  children?: ReactNode;
}

export function Card({ variant = "legacy", header, flush, className, children, ...rest }: CardProps) {
  return (
    <div className={cx(styles.card, styles[variant], className)} {...rest}>
      {header !== undefined && <div className={styles.header}>{header}</div>}
      <div className={cx(styles.body, flush && styles.flush)}>{children}</div>
    </div>
  );
}
